import { useNavigate } from "react-router-dom";
import { StatusChip } from "../../utils/chipUtils";

function UserRole() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <div>
          <h5>User Role Access</h5>
        </div>
        <button
          className="btn--sm btn-primary"
          onClick={() => navigate("createuserrole")}
        >
          Create New Role
        </button>
      </div>
      <div className="mt-4 cover border rounded-border-sm">
        <table>
          <thead>
            <tr>
              <th>Role Name</th>
              <th>Total Users</th>
              <th>Created on</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="table-body">
            {userData.map((data) => (
              <tr>
                <td>{data.username}</td>
                <td>{data.userid}</td>
                <td>{data.role}</td>
                <td>
                  <StatusChip status={data.status} />
                </td>
                <td>
                  <div className="list-icon">
                    <span class="material-symbols-rounded">edit</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const userData = [
  {
    username: "Muhil Rajan",
    userid: "CS417022",
    mailid: "muhil.rajan@adityabirlacapital.com",
    role: "Admin",
    status: "Active",
  },
  {
    username: "Koil Raj",
    userid: "SS417021",
    mailid: "koilraj@adityabirlacapital.com",
    role: "Frontline",
    status: "InActive",
  },
];

export default UserRole;
